import { render, staticRenderFns } from "./PatientDiagramStep.vue?vue&type=template&id=77058b02&scoped=true&"
import script from "./PatientDiagramStep.vue?vue&type=script&lang=js&"
export * from "./PatientDiagramStep.vue?vue&type=script&lang=js&"
import style0 from "./PatientDiagramStep.vue?vue&type=style&index=0&id=77058b02&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77058b02",
  null
  
)

export default component.exports